// src/pages/markets/board/board/sortKeys.ts
//
// Sort keys a column header does not list unless they are the one in use. Kept
// in its own file so the desktop and the phone header read one list.

export const HIDDEN_SORT_KEYS = new Set(['implied_disparity', 'implied_prob']);
